module.exports = "https://cdn.redage.net/src/views/donate/main/assets/images/menu/shop.png";